module.exports = __webpack_public_path__ + "static/pic08-761e2afcfcf9128d9d7d823436ff3af7.png";